const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
  },

  children: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
  },

  loading: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 200,
  },

  empty: {
    flex: '1 1 auto',
    fontSize: 15,
    color: '#A9B0B8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 100,
  },
});

export default styles;
